module.exports = __webpack_public_path__ + "img/9.4ffc2435.png";